import React, { useState, useEffect } from 'react';


const IDInput = (props) => {

    return (
        <div><input type="text" size="50" autoFocus placeholder="Enter the Unique Identifier here" onChange={(e) => props.onRecallIDChange(e.target.value)} />
        </div>
    )
}
export default IDInput;